import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export const NewReportIcon = (props: IconProps): JSX.Element => (
  <Icon viewBox="0 0 15.8333 17.7083" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 1.5625C1.25 1.38991 1.38991 1.25 1.5625 1.25H5.3125C6.52062 1.25 7.5 2.22938 7.5 3.4375V4.6875C7.5 5.55045 8.19955 6.25 9.0625 6.25H10.3125C11.5206 6.25 12.5 7.22938 12.5 8.4375V9.80101C12.5686 9.79483 12.6381 9.79167 12.7083 9.79167C13.0834 9.79167 13.4375 9.88178 13.75 10.0415V8.125C13.75 3.63769 10.1123 0 5.625 0H1.5625C0.699555 0 0 0.699555 0 1.5625V15.9375C0 16.8004 0.699555 17.5 1.5625 17.5H10.4545C10.4296 17.3649 10.4167 17.2256 10.4167 17.0833V16.875H10.2083C9.59936 16.875 9.04586 16.6375 8.63544 16.25H1.5625C1.38991 16.25 1.25 16.1101 1.25 15.9375V1.5625ZM8.75 3.4375C8.75 2.84729 8.60126 2.29183 8.33921 1.80654C9.95376 2.50102 11.249 3.79624 11.9435 5.4108C11.4582 5.14875 10.9027 5 10.3125 5H9.0625C8.88991 5 8.75 4.86009 8.75 4.6875V3.4375Z"
      fill="currentColor"
    />
    <path
      d="M10 12.301C9.52731 12.3436 9.096 12.5297 8.75 12.8155V8.75C8.75 8.40482 9.02982 8.125 9.375 8.125C9.72018 8.125 10 8.40482 10 8.75V12.301Z"
      fill="currentColor"
    />
    <path
      d="M7.5 10.625C7.5 10.2798 7.22018 10 6.875 10C6.52982 10 6.25 10.2798 6.25 10.625V13.125C6.25 13.4702 6.52982 13.75 6.875 13.75C7.22018 13.75 7.5 13.4702 7.5 13.125V10.625Z"
      fill="currentColor"
    />
    <path
      d="M5 12.5C5 12.1548 4.72018 11.875 4.375 11.875C4.02982 11.875 3.75 12.1548 3.75 12.5V13.125C3.75 13.4702 4.02982 13.75 4.375 13.75C4.72018 13.75 5 13.4702 5 13.125V12.5Z"
      fill="currentColor"
    />
    <path
      d="M13.3333 12.0833C13.3333 11.7382 13.0535 11.4583 12.7083 11.4583C12.3632 11.4583 12.0833 11.7382 12.0833 12.0833V13.9583H10.2083C9.86316 13.9583 9.58333 14.2382 9.58333 14.5833C9.58333 14.9285 9.86316 15.2083 10.2083 15.2083H12.0833V17.0833C12.0833 17.4285 12.3632 17.7083 12.7083 17.7083C13.0535 17.7083 13.3333 17.4285 13.3333 17.0833V15.2083H15.2083C15.5535 15.2083 15.8333 14.9285 15.8333 14.5833C15.8333 14.2382 15.5535 13.9583 15.2083 13.9583H13.3333V12.0833Z"
      fill="currentColor"
    />
  </Icon>
);

export default NewReportIcon;
